/// <reference path="../../../mobile/core/services/broker.service.ts"/>
/**
 * Created by bdickson on 22/01/2016.
 */

namespace core {
    type Broker = Core.Broker;

    class NavigationDrawer {

        open:boolean;

        constructor() {
        }

        init(scope:ng.IScope, broker:Broker) {

            this.open = false;

            // subscribe to toggle request from external source (e.g. a button in the site header)
            broker.subscribe('NavigationDrawer', 'toggleNavigationDrawer', ()=> {
                this.open = !this.open;
            });

            scope.$on('$destroy', () => {
                broker.unsubscribe('NavigationDrawer');
            });

        }
    }

    angular
        .module('core')
        .directive('navigationDrawer', (broker:Broker) => {

                let config = {
                    controller: NavigationDrawer,
                    controllerAs: 'nd',
                    bindToController: true,
                    transclude: TRPCONFIG.Domain.ResponsiveNavDrawer
                };

                let templateUrl = TRPCONFIG.Domain.ResponsiveNavDrawer ? '<div><div ng-transclude></div></div>'
                    : 'partials/home/directivetemplate?type=NavigationDrawer';

                let directive = TRPCONFIG.Domain.ResponsiveNavDrawer
                    ? angular.merge(config, {template: templateUrl})
                    : angular.merge(config, {templateUrl: templateUrl});

                directive.link = function (scope:ng.IScope, el:ng.IAugmentedJQuery, attr, controller:NavigationDrawer) {
                    controller.init(scope, broker);
                };

                return directive;
            }
        )
    ;

}
